import useSWR from 'swr';

import { ENDPOINTS } from '@/api/endpoints';
import { getAISearchDocs } from '@/api/ai-search-docs';

export const useGetAISearchDocs = () => {
  const { data, isLoading, mutate, isValidating } = useSWR(
    ENDPOINTS.AI_SEARCH_DOCS,
    () => getAISearchDocs(),
    { revalidateOnFocus: false }
  );

  return {
    docs: data ?? [],
    loading: isLoading,
    validating: isValidating,
    refetchDocs: mutate,
  };
};
